/*
 * @Author: chenxt
 * @Date: 2025-04-11 13:48:24
 * @Description: 获取状态name值
 */

const getName = (stateId) => {
    let name = ''
    const arr = [
        {value:'0',name:'未填报'},
        {value:'1',name:'未提交'},
        {value:'11',name:'县市区待审核'},
        {value:'12',name:'县市区已审核'},
        {value:'21',name:'地州市待审核'},
        {value:'22',name:'地州市已审核'},
        {value:'31',name:'自治区待审核'},
        {value:'32',name:'自治区已审核'},
        {value:'90',name:'地州市已退回'},
        {value:'95',name:'已退回'},
        {value:'99',name:'自治区已退回'}
    ]
    arr.forEach(i=> {
        if(i.value == stateId) {
            name = i.name
        }
    })
    return name
}
export { getName };
